class CareGuideTrigger extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector("button");
    this.template = this.querySelector("template");

    this.button.addEventListener("click", () => {
      this.button.dispatchEvent(
        new CustomEvent("markup-modal:open", {
          bubbles: true,
          detail: { target: "care-guide-modal", html: this.template.innerHTML },
        }),
      );
    });
  }
}

if (!customElements.get("care-guide-trigger")) {
  customElements.define("care-guide-trigger", CareGuideTrigger);
}
